export default __webpack_public_path__ + "static/media/location_icon_yellow.c3e20624.png";